import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./features/layout/AppShell.js";
import { ArtistsList } from "./features/library/ArtistsList.js";
import { ArtistForm } from "./features/library/ArtistForm.js";
import { BandsList } from "./features/library/BandsList.js";
import { BandNew } from "./features/library/BandNew.js";
import { BandDetail } from "./features/library/BandDetail.js";
import { BandEdit } from "./features/library/BandEdit.js";
import { Library } from "./features/library/Library.js";
import { SongEditorPage } from "./features/song-editor/SongEditorPage.js";

export function App(): JSX.Element {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/bands" replace />} />
          <Route path="/bands" element={<BandsList />} />
          <Route path="/bands/new" element={<BandNew />} />
          <Route path="/bands/:id" element={<BandDetail />} />
          <Route path="/bands/:id/edit" element={<BandEdit />} />
          <Route path="/artists" element={<ArtistsList />} />
          <Route path="/artists/new" element={<ArtistForm mode="new" />} />
          <Route path="/artists/:id/edit" element={<ArtistForm mode="edit" />} />
          <Route path="/songs/:songId" element={<SongEditorPage />} />
          <Route path="/library" element={<Library />} />
          <Route path="*" element={<Navigate to="/bands" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
